import * as Immutable from "immutable";
import ParameterBinding from "views/logic/parameters/ParameterBinding";
const bindParametersFromQuery = async ({ query, view, executionState }) => {
  var _a, _b;
  const parameters = (_b = (_a = view.search) == null ? void 0 : _a.parameters) != null ? _b : Immutable.Set();
  const queryParameterValues = Immutable.Map(query).filter((_, key) => parameters.find((p) => p.name === key) !== void 0).toMap();
  let { parameterBindings } = executionState;
  parameters.forEach((parameter) => {
    if (queryParameterValues.get(parameter.name) || parameter.defaultValue) {
      parameterBindings = parameterBindings.set(
        parameter.name,
        ParameterBinding.forValue(queryParameterValues.get(parameter.name, parameter.defaultValue))
      );
    }
  });
  const newExecutionState = executionState.toBuilder().parameterBindings(parameterBindings).build();
  return [view, newExecutionState];
};
export default bindParametersFromQuery;
